import { natif } from '../plateforme';
import { useState, useEffect } from 'react';
import { getDemandeAbonnement, demanderAbonnement, getFondateur } from '../api';

const champ = { width:'100%', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:9,
                padding:'10px 12px', color:'var(--text)', fontSize:14 };

/** Bouton « Passer à l'abonnement » et son formulaire, pour l'admin du club. */
export default function DemandeAbonnement({ style }) {
  const [ouvert, setOuvert] = useState(false);
  const [enCours, setEnCours] = useState(null);
  const [f, setF] = useState({ formule: 'annuel' });   // la saison, proposée par défaut
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [places, setPlaces] = useState(null);
  // Applications des stores : aucun achat d'abonnement (règles d'Apple et de Google). Il se prend sur le site.
  if (natif) return null;
  useEffect(() => { getDemandeAbonnement().then(setEnCours).catch(() => {}); }, []);
  useEffect(() => {
    getFondateur().then(p => { setPlaces(p); if (p.restantes > 0) setF(x => ({ ...x, formule: 'fondateur' })); }).catch(() => {});
  }, []);

  if (enCours?.en_cours) return (
    <span style={{ display:'inline-block', fontSize:12.5, fontWeight:700, color:'#22c55e', ...style }}>
      {enCours.automatique
        ? <>✓ Abonnement souscrit. Votre facture vous sera envoyée par email{enCours.email_facturation ? ` à ${enCours.email_facturation}` : ''} dans les 24 heures, avec un lien de paiement par carte. L'abonnement est activé dès son règlement.</>
        : <>✓ Demande d'abonnement transmise — nous revenons vers vous rapidement</>}</span>);

  async function envoyer(e) {
    e.preventDefault(); setEnvoi(true); setErreur(null);
    try { await demanderAbonnement(f); setEnCours(await getDemandeAbonnement().catch(() => ({ en_cours: true, formule: f.formule }))); setOuvert(false); }
    catch (err) { setErreur(err.message); }
    finally { setEnvoi(false); }
  }

  const formule = (k, titre, prix, detail) => (
    <button type="button" onClick={() => setF({ ...f, formule: k })}
      style={{ flex:1, textAlign:'left', padding:'12px 13px', borderRadius:10, cursor:'pointer', background:'var(--bg)',
               border:`1.5px solid ${f.formule === k ? 'var(--accent)' : 'var(--border)'}` }}>
      <div style={{ fontSize:12, fontWeight:700, color: f.formule === k ? 'var(--accent)' : 'var(--muted)', textTransform:'uppercase', letterSpacing:1 }}>{titre}</div>
      <div style={{ fontSize:18, fontWeight:800, color:'var(--text)', margin:'3px 0 1px' }}>{prix}</div>
      <div style={{ fontSize:11.5, color:'var(--muted)' }}>{detail}</div>
    </button>);

  return (
    <>
      <button className="btn btn-primary" onClick={() => setOuvert(true)}
              style={{ width:'auto', padding:'10px 18px', fontSize:13, ...style }}>Passer à l'abonnement</button>
      {ouvert && (
        <div role="dialog" aria-modal="true" onClick={e => e.target === e.currentTarget && setOuvert(false)}
             style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.65)', zIndex:4000, display:'flex',
                      alignItems:'flex-end', justifyContent:'center', padding:12 }}>
          <form onSubmit={envoyer} style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:16,
                                           padding:'20px 18px', width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto',
                                           marginBottom:'env(safe-area-inset-bottom, 0px)', textAlign:'left' }}>
            <div style={{ fontFamily:'Barlow Condensed', fontSize:22, fontWeight:800, marginBottom:4 }}>Passer à l'abonnement</div>
            <div style={{ fontSize:12.5, color:'var(--muted)', marginBottom:16, lineHeight:1.55 }}>
              Toutes les équipes du club comprises. Nous vous envoyons la facture, et votre accès continue sans interruption.</div>
            {places?.restantes > 0 && (
              <div style={{ display:'flex', marginBottom:9 }}>
                {formule('fondateur', '★ Offre fondateur', '150 € TTC',
                         `la saison, garanti deux saisons · plus que ${places.restantes} place${places.restantes > 1 ? 's' : ''}`)}
              </div>)}
            <div style={{ display:'flex', gap:9, marginBottom:16 }}>
              {formule('annuel', 'Saison', '250 € TTC', '12 mois, deux offerts')}
              {formule('mensuel', 'Mensuel', '25 € TTC', 'par mois, sans engagement')}
            </div>
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Email de facturation *</label>
            <input style={{ ...champ, marginBottom:11 }} type="email" required value={f.email_facturation||''}
                   onChange={e => setF({ ...f, email_facturation: e.target.value })} placeholder="tresorier@club.fr" />
            <div style={{ fontSize:12, color:'var(--muted)', margin:'4px 0 9px' }}>Pour la facture, telle qu'elle figure dans les statuts de l'association :</div>
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Nom officiel du club *</label>
            <input style={{ ...champ, marginBottom:11 }} required maxLength={150} value={f.denomination||''}
                   onChange={e => setF({ ...f, denomination: e.target.value })} placeholder="Club Handball de …" />
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Adresse *</label>
            <input style={{ ...champ, marginBottom:11 }} required maxLength={300} value={f.adresse||''}
                   onChange={e => setF({ ...f, adresse: e.target.value })} placeholder="Numéro et rue" />
            <div style={{ display:'flex', gap:9, marginBottom:11 }}>
              <div style={{ flex:'0 0 34%' }}>
                <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Code postal *</label>
                <input style={champ} required inputMode="numeric" pattern="[0-9]{5}" maxLength={5} value={f.code_postal||''}
                       onChange={e => setF({ ...f, code_postal: e.target.value.replace(/\D/g, '') })} />
              </div>
              <div style={{ flex:1 }}>
                <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Ville *</label>
                <input style={champ} required maxLength={80} value={f.ville||''} onChange={e => setF({ ...f, ville: e.target.value })} />
              </div>
            </div>
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Numéro SIREN de l'association {f.sans_siren ? '' : '*'}</label>
            <input style={{ ...champ, marginBottom:6, opacity: f.sans_siren ? .5 : 1 }} required={!f.sans_siren} disabled={!!f.sans_siren}
                   inputMode="numeric" maxLength={11} value={f.sans_siren ? '' : (f.siren||'')} placeholder="9 chiffres : le début de son SIRET"
                   onChange={e => setF({ ...f, siren: e.target.value.replace(/[^\d ]/g, '') })} />
            <label style={{ display:'flex', gap:7, alignItems:'center', fontSize:12, color:'var(--muted)', marginBottom:11, cursor:'pointer' }}>
              <input type="checkbox" checked={!!f.sans_siren} onChange={e => setF({ ...f, sans_siren: e.target.checked })} />
              Notre association n'a pas de numéro SIREN
            </label>
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Numéro RNA (facultatif)</label>
            <input style={{ ...champ, marginBottom:11 }} maxLength={10} value={f.rna||''} placeholder="W281000123"
                   onChange={e => setF({ ...f, rna: e.target.value.toUpperCase() })} />
            <label style={{ display:'block', fontSize:12, color:'var(--muted)', marginBottom:5 }}>Un message ?</label>
            <textarea style={{ ...champ, minHeight:64, resize:'vertical', marginBottom:14 }} value={f.message||''} maxLength={1000}
                      onChange={e => setF({ ...f, message: e.target.value })} />
            {erreur && <div style={{ color:'var(--danger)', fontSize:13, marginBottom:12 }}>{erreur}</div>}
              {enCours?.cgv && (
                <label style={{ display:'flex', gap:8, alignItems:'flex-start', fontSize:12.5, lineHeight:1.5, margin:'4px 0 12px', cursor:'pointer' }}>
                  <input type="checkbox" required checked={!!f.accepte_cgv} onChange={e => setF({ ...f, accepte_cgv: e.target.checked })} style={{ marginTop:3 }} />
                  <span>J'accepte les <a href={enCours.cgv.url_cgv} target="_blank" rel="noreferrer">conditions générales de vente</a> et
                    le <a href={enCours.cgv.url_dpa} target="_blank" rel="noreferrer">contrat de sous-traitance</a> d'Équipote.</span>
                </label>)}
            <div style={{ display:'flex', gap:9 }}>
              <button className="btn btn-primary" disabled={envoi}>
                {/* Facturation automatique : le bouton engage le club, il le dit clairement */}
                {enCours?.automatique ? (envoi ? 'Souscription…' : "Souscrire l'abonnement") : (envoi ? 'Envoi…' : 'Envoyer la demande')}</button>
              <button type="button" className="btn btn-secondary" onClick={() => setOuvert(false)}>Annuler</button>
            </div>
          </form>
        </div>)}
    </>
  );
}
